import React from "react";
import { useTranslation } from "react-i18next";

const BenefitDeleted = ({ notification }) => {
  const { t } = useTranslation();

  const benefitName = notification?.payload?.benefitName || "";

  return (
    <>
      <h4 className="notification-title">
        {t("notification_benefit_deleted_title", { benefitName })}
      </h4>
      <p className="notification-subtitle">
        {t("notification_benefit_deleted_subtitle")}
      </p>
      <p className="subtitle-description">
        {t("notification_benefit_deleted_description")}
      </p>
    </>
  );
};

export default BenefitDeleted;
